import React from "react";
import { useSalesCount, useMoveNextDate } from "./api";
import Nav from "./Nav";

const Move = () => {
  const { data, isLoading, isError } = useSalesCount();
  const moveNextDate = useMoveNextDate();

  const handleMove = () => {
    if (window.confirm("Are you sure you want to move to the next date?")) {
      moveNextDate.mutate();
    }
  };

  if (isLoading) return <div className="text-center mt-5">Loading...</div>;
  if (isError)
    return (
      <div className="text-center mt-5 text-danger">
        Error loading sales count
      </div>
    );

  return (
    <>
      <Nav />

      <style>
        {`
          .move-container {
            max-width: 600px;
            margin: 50px auto;
          }
          .move-card {
            border-radius: 15px;
            box-shadow: 0px 5px 15px rgba(0,0,0,0.1);
          }
          .move-header {
            background: linear-gradient(135deg, #007bff, #0056b3);
            color: white;
            border-radius: 15px 15px 0 0;
            padding: 20px;
            text-align: center;
          }
          .move-body {
            padding: 25px;
          }
          .move-btn {
            width: 100%;
            font-weight: bold;
            padding: 12px;
            border-radius: 10px;
          }
          .status-msg {
            font-weight: 500;
            margin-top: 15px;
            text-align: center;
          }
        `}
      </style>

      <div className="container move-container">
        <div className="card move-card">
          <div className="move-header">
            <h2>📊 Sales Dashboard</h2>
          </div>
          <div className="move-body">
            <p>
              <strong>Past Sales:</strong> {data?.past_count}
            </p>
            <p>
              <strong>Present & Future Sales:</strong> {data?.future_count}
            </p>

            <button
              onClick={handleMove}
              disabled={moveNextDate.isLoading}
              className="btn btn-primary move-btn mt-3"
            >
              {moveNextDate.isLoading ? "Moving..." : "➡ Move to Today Date"}
            </button>

            {moveNextDate.isError && (
              <p className="status-msg text-danger">❌ Failed to move date</p>
            )}
            {moveNextDate.isSuccess && (
              <p className="status-msg text-success">
                ✅ {moveNextDate.data.moved_count} records moved to today (
                {moveNextDate.data.date})
              </p>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default Move;
